import clientService from 'services/client-service';
import billingMethodType from "enums/billing-method";

const defaultClient = {
  name: null,
  ownerFirstName: null,
  ownerLastName: null,
  ownerEmail: null,
  ownerPhoneNumber: null,
  billingMethod: billingMethodType.ClientBilling,
  type: null,
};

const state = {
  client: defaultClient,
  clients: [],
  apiKeys: {
    clientId: null,
    clientSecret: null
  }
};

const actions = {
  async loadClient({ commit }, id) {
    const client = id
      ? await clientService.get(id)
      : { ...defaultClient };

    commit('client-loaded', client);
  },

  async resendInvite({ commit }, id) {
    await clientService.resendInvite(id);

    commit('invite-resent', id);
  },

  async saveClient({ commit }, client) {
    client.id
      ? await clientService.update(client)
      : await clientService.create(client);

    commit('client-saved');
  },

  async getClientsForFilter({ commit }) {
    const clients = await clientService.getForFilter();

    const selectList = clients.map(c => {
      return {
        text: c.text,
        label: c.text,
        value: c.value
      }
    }).sort((a, b) => a.label.localeCompare(b.label));

    commit('get-clients', selectList);
  },

  async regenerateApiKeys({ commit }, id) {
    const keys = await clientService.regenerateApiKeys(id);

    commit('load-api-keys', keys);
  },

  async loadApiKeys({ commit }, id) {
    const keys = await clientService.loadApiKeys(id);
    
    commit('load-api-keys', keys);
  }
};

const mutations = {
  'client-loaded'(state, client) {
    state.client = client;
  },

  'invite-resent'() {
  },

  'client-saved'() {
  },

  'get-clients'(state, clients) {
    state.clients = clients
  },

  'load-api-keys'(state, keys) {
    state.apiKeys = keys
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
}